/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ImageTaskIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ImageTaskIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ImageTaskIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#0E3958"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ImageTaskIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-3OgeA': alignSelf,'--mt-2-3OgeA': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-3OgeA': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-3OgeA': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-3OgeA': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-3OgeA': opacity,'--w-10-3OgeA': typeof width === 'number' ? `${width}px` : width,'--h-11-3OgeA': typeof height === 'number' ? `${height}px` : height,'--f-12-3OgeA': fill,'--a-7-3OgeA': isAnimated ? animation : "none",'--sd-8-3OgeA': isAnimated ? strokeDashoffset : 0,'--sd-9-3OgeA': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ImageTaskIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2.25 1.929a.322.322 0 00-.321.321v1.929a.964.964 0 01-1.929 0V2.25A2.25 2.25 0 012.25 0h1.929a.964.964 0 110 1.929H2.25zm14.786 10.928c.532 0 .964.432.964.964v1.929A2.25 2.25 0 0115.75 18h-1.929a.964.964 0 010-1.929h1.929a.321.321 0 00.321-.321v-1.929c0-.532.432-.964.965-.964zm-15.107.964a.964.964 0 00-1.929 0v1.929A2.25 2.25 0 002.25 18h1.929a.964.964 0 100-1.929H2.25a.321.321 0 01-.321-.321v-1.929zM12.857.964c0-.532.432-.964.964-.964h1.929A2.25 2.25 0 0118 2.25v1.929a.964.964 0 11-1.929 0V2.25a.321.321 0 00-.321-.321h-1.929a.964.964 0 01-.964-.965zM9 2.732A6.294 6.294 0 109 15.32 6.294 6.294 0 009 2.732zm2.455 7.184a.804.804 0 01.352 1.08l-.716-.363.716.364v.002l-.002.001-.002.004-.005.01-.012.022-.037.063a2.837 2.837 0 01-.618.685c-.459.365-1.155.698-2.131.698-.976 0-1.672-.333-2.131-.698a2.836 2.836 0 01-.618-.685 1.778 1.778 0 01-.037-.063l-.012-.023-.005-.009L6.195 11 6.194 11s0-.002.715-.366l-.716.364a.804.804 0 011.425-.743l.002.003a1.234 1.234 0 00.251.27c.197.157.546.348 1.129.348.584 0 .932-.19 1.13-.348a1.234 1.234 0 00.25-.27l.002-.003a.804.804 0 011.073-.338zM6.56 6.59a.964.964 0 110 1.929.964.964 0 010-1.929zm4.878 0a.964.964 0 110 1.929.964.964 0 010-1.929z"
 style={{'--f-12-3OgeA': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}